export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5638.88e4788e.jpg";